<template>
  <article class="card">
    <CardHeader>
      <span v-text="'Email'" />
      <span
        v-if="email.attributes.status === 'delivered' || email.attributes.status === 'archived'"
        v-text="`Delivered At ${deliveryDate}`"
      />
      <span
        v-else
        v-text="`Delivery Date: ${deliveryDate}`"
      />
      <strong>
        <AuthorName
          :full-name="email.author.attributes.full_name"
          :is-a-shared-copy="email.attributes.is_a_shared_copy"
          :sharing-union-name="email.attributes.sharing_union_name"
        />
      </strong>
      <span v-can="['view-email-recipients', 'edit-email', 'archive-email', 'delete-email']">
        <CommPopper
          ref="commPopper"
          :options="{ placement: 'bottom-end' }"
        >
          <div
            slot="content"
            class="flex flex-col"
          >
            <a
              v-if="email.attributes.status === 'delivered' || email.attributes.status === 'delivery-in-progress' || email.attributes.status === 'archived'"
              v-can="'view-email-recipients'"
              :href="deliveryUrl"
              v-text="'View Deliveries'"
            />
            <a
              v-if="email.attributes.status === 'draft' || email.attributes.status === 'scheduled' "
              v-can="'edit-email'"
              :href="editUrl"
              v-text="'Edit'"
            />
            <a
              v-if="email.attributes.status !== 'archived'"
              v-can="'archive-email'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($emit('openArchiveModal', email))"
              v-text="'Archive'"
            />
            <a
              v-can="'share-comms'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($root.openModalWithPayload('sendCommToOrganizationsModal', email))"
              v-text="'Share with Organization'"
            />
            <a
              v-if="email.attributes.status === 'archived'"
              v-can="'archive-email'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($store.commit('communicationOpenRestoreArchivedCommunicationModal', email))"
              v-text="'Restore'"
            />
            <a
              v-can="'delete-email'"
              href="#"
              @click.prevent="$refs.commPopper.close().then($emit('openDeleteModal', email))"
              v-text="'Delete'"
            />
          </div>
        </CommPopper>
      </span>
    </CardHeader>
    <div class="flex sm:flex-wrap md:flex-no-wrap">
      <div class="card-content">
        <h3 class="-mb-2">
          <a
            :href="detailsUrl"
            v-text="email.attributes.subject"
          />
        </h3>
        <p v-html="email.attributes.body_short" />
        <a
          :href="detailsUrl"
          v-text="'Read More'"
        />
      </div>
    </div>
  </article>
</template>

<script type="text/babel">
import CardHeader from './CommunicationCardHeader'
import CommPopper from './CommPopper'
import AuthorName from './SharedCommunicationAuthorName'

export default {
  name: 'EmailCard',
  components: {
    AuthorName,
    CommPopper,
    CardHeader,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
  computed: {
    deliveryDate() {
      return this.email.attributes.delivery_date
        ? this.moment(this.email.attributes.delivery_date).format(this.$root.commDateFormat)
        : 'Not Set'
    },
    detailsUrl() {
      return this.$urlGenerator.active(`communications/email/${this.email.uuid}`)
    },
    editUrl() {
      return this.$urlGenerator.active(`communications/email/${this.email.uuid}/edit`)
    },
    deliveryUrl() {
      return this.$urlGenerator.active(`communications/email/${this.email.uuid}/deliveries`)
    },
  },
}
</script>
